import React from 'react'
import { useHistory } from 'react-router-dom'
import {
  ExternalLink as ExternalLinkIcon,
  Folder as FolderIcon,
} from 'react-feather'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { reverse } from 'named-urls'
import { Box, IconButton, Paper, Typography } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import helpers from 'helpers'

import theme from 'theme'
import { routes } from 'Routes'

const FolderTable = ({ folders = [], isLoading = false }) => {
  const history = useHistory()

  const handleRedirect = (folderId) => {
    return history.push(
      reverse(routes.documents.folders.show, {
        folderId,
      }),
    )
  }

  return (
    <Box component={Paper}>
      <PerfectScrollbar
        options={{ wheelPropagation: true, useBothWheelAxes: true }}
      >
        <Table
          emptyMessage="Nenhum modelo de documento foi encontrado."
          isLoading={isLoading}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell width="85%">Pasta</TableCell>
              <TableCell width="10%" align="center">
                Atualizado em
              </TableCell>
              <TableCell align="right" width="5%">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {folders?.map((folder) => (
              <TableRow key={folder?.id}>
                <TableCell width="85%">
                  <Box
                    display="flex"
                    alignItems="center"
                    gridGap={theme.spacing(1)}
                  >
                    <FolderIcon size={20} />
                    <Typography>{folder?.name}</Typography>
                  </Box>
                </TableCell>
                <TableCell width="10%" align="center">
                  {helpers.formatters.dates.ptBrFormatDateTime(
                    folder?.updatedAt,
                  )}
                </TableCell>
                <TableCell align="right" width="5%">
                  <IconButton
                    size="small"
                    onClick={() => handleRedirect(folder?.id)}
                  >
                    <ExternalLinkIcon size={20} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

export default FolderTable
